import { render, staticRenderFns } from "./user-manager.vue?vue&type=template&id=6a83a530&scoped=true"
var script = {}
import style0 from "./user-manager.vue?vue&type=style&index=0&id=6a83a530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83a530",
  null
  
)

export default component.exports